module.exports = __webpack_public_path__ + "static/media/TRUST_LOGO.f633739a.svg";